import { graphql } from '../graphql';

export const unfollowPropertyV2Mutation = graphql(`
  mutation unfollowPropertyV2($propertyId: String!) {
    unfollowPropertyV2(propertyId: $propertyId) {
      _id
      followedProperties {
        id
        relationship
      }
    }
  }
`);
